import LogoApp from "./logoapp";

const CardDiskualifikasi = (props) => {
  return (
    <>
      <div className="rounded-lg w-full  md:h-max flex flex-col justify-between items-center px-5 md:w-1/2 bg-[#ffffffd9] border-[4px]  py-5">
        <div className="flex flex-col justify-center items-center w-full">
          <LogoApp />

          <div className="text-2xl text-center font-bold text-gray-700">
            {props?.user?.firstname} {props?.user?.lastname}
          </div>

          <div className="uppercase mb-4 text-2xl text-center font-bold text-black">
            {props?.config?.disqualified}
          </div>
          <h1 className="text-lg font-bold ">
            {props?.activity?.activity_round +
              " - " +
              props?.activity?.activity_name}
          </h1>
        </div>

        {/* <div className="w-full flex justify-center items-center mt-5">
          <a
            href="/leaderboard-round1"
            className="w-full font-bold cursor-pointer flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-blue-700 bg-blue-500  rounded-lg "
          >
            VIEW ROUND 1 LEADERBOARD
          </a>
        </div>

        <div className="w-full flex justify-center items-center mt-2">
          <a
            href="/leaderboard-round2"
            className="w-full font-bold cursor-pointer flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-blue-700 bg-blue-500  rounded-lg "
          >
            VIEW ROUND 2 LEADERBOARD
          </a>
        </div> */}

        <div className="w-full flex justify-center items-center mt-5">
          <a
            href="/leaderboard"
            className="w-full font-bold cursor-pointer flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-blue-700 bg-blue-500  rounded-lg "
          >
            VIEW LEADERBOARD
          </a>
        </div>

        <div className="w-full flex justify-center items-center mt-2">
          <a
            href="/leaderboard-individual"
            className="w-full font-bold cursor-pointer flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-blue-700 bg-blue-500  rounded-lg "
          >
            VIEW INDIVIDUAL POINTS
          </a>
        </div>

        <div className="flex mt-4 justify-between w-full">
          <a
            href="/"
            className="font-bold cursor-pointer w-full flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-red-700 bg-red-500 rounded-lg "
          >
            BACK
          </a>
        </div>
      </div>
    </>
  );
};

export default CardDiskualifikasi;
